export const CHECKOUT_FORM_NAME = 'checkoutForm';
